export default () => ({
    portfolio: null,
    mobileFilter: false,
    getPortfolio() {
        console.log('get all');
        fetch('/portfolio.json')
            .then((res) => res.json())
            .then((json) => {
                this.portfolio = json
            });
    },

    getCategories(loc) {
        // console.log('get categories')
        fetch('/portfolio.json/category:' + loc)
            .then((res) => res.json())
            .then((json) => {
                this.portfolio = json
            });
    },

    getLocations(loc) {
        console.log('get locations')
        fetch('/portfolio.json/location:' + loc)
            .then((res) => res.json())
            .then((json) => {
                this.portfolio = json
            });
    },

    showFilter() {

    },

    filterPortfolio(tag) {
        console.log('filterPortfolio: ' + tag);
        document.querySelectorAll('.dropdown > button').forEach(el => {
            console.log(el);
        })
    },
    
})